<!-- <div class="container-full-width">
  <div class="device-list-cardview">
      <p-accordion [activeIndex]="0" width="100%">
      <p-accordionTab *ngFor="let group of groupedByDeviceGroups" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
          <ng-template pTemplate="header">
              <div class="accordion-header-container">
              <div class="accordion-header-content">
                  <div class="accordion-header-title">
                  {{group.groupName}}
                  </div>
              </div>
              </div>
              <div class="accordion-header-divider"></div>
          </ng-template>
          <div class="card-grid-container">

              <div *ngFor="let item of group.items" class="card-item-wrapper">
              <div class="card-inner-container">

                  <div class="card-icon-column">
                      <img class="card-icon-device" src="assets/cardicons/Immagine2.png" />
                      <img class="card-icon-edge" src="assets/cardicons/AIR Edge.png" />
                      <div class="card-edit-button-container">
                          <qds-button size="small" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="pencil"></qds-button>
                          
                      </div>
                  </div>
                  <div class="card-content-column">
                      <div class="card-info-row">
                          <div class="info-box-iot-edge">
                              <div class="info-box-content">
                                  <div class="info-label-kicker">IoT Edge Name</div>
                                  <div class="info-value-link">{{item.name}}</div>
                                  <div class="info-value-subtitle">{{item.dongleUId}}</div>
                              </div>
                              <qds-button size="small" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="pencil"></qds-button>

                          </div>
                          <div class="info-box-device-model">
                              <div class="info-box-device-model-inner">
                                  <div class="info-box-padding">
                                      <div class="info-box-column-flex">
                                          <div class="info-label-kicker">Device Model</div>
                                          <div class="info-value-title">{{item.controllerTypeName}}</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="subscription-container">
                              <div class="subscription-info-column">
                                  <div class="subscription-label">Subscription Type</div>
                                  <div class="subscription-type-strikethrough">Silent Guardian PLUS</div>
                                  <div class="subscription-date">30/10/2025</div>
                              </div>
                              <div class="renew-button-container">
                                  <div class="renew-button">
                                      <div class="renew-button-text">Renew</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="temperature-section">
                          <div class="temperature-row">
                              <div class="temperature-column">
                                  <div class="temperature-top-section">
                                      <div class="temperature-values-container">
                                          <div class="temperature-values-row">
                                              <div class="current-value-column">
                                              <div class="current-value-number">6.1 </div>
                                              
                                                  <div class="current-value-label">Current Value</div>
                                              </div>
                                              <div class="setpoint-column">
                                                  <div class="setpoint-number">5.0</div>
                                                  <div class="setpoint-label">Set Point</div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="status-buttons-row">
                                      <div class="status-buttons-container">
                                          <div class="status-buttons-flex-row">
                                              <div class="status-icon-button">
                                                  <div class="status-icon-content">
                                                      <qds-button size="large" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="snowflake"></qds-button>
                                                  </div>
                                                  
                                              </div>
                                              <div class="status-icon-button-active">
                                                  <div class="status-icon-content-contrast">
                                                      <qds-button size="large" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="wind-turbine"></qds-button>
                                                  </div>
                                              </div>
                                              <div class="status-icon-button">
                                                  <div class="status-icon-content">
                                                      <qds-button size="large" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="light-bulb-filled-on"></qds-button>
                                                  </div>
                                              </div>
                                              <div class="status-icon-button">
                                                  <div class="status-icon-content">
                                                      <qds-button size="large" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="door-opened"></qds-button>
                                                  </div>
                                              </div>
                                              <div class="status-icon-button-alert">
                                                  <div class="status-icon-content-contrast">
                                                      <qds-button size="large" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="bell-waves"></qds-button>
                                                  </div>
                                              </div>
                                              <div class="status-icon-button-flex">
                                                   <div class="status-icon-content-contrast">
                                                      <qds-button size="large" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="link-slash"></qds-button>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          
                      </div>
                  </div>

              </div>
              <qds-icon class="qds-icon map-tooltip-dots" name="dots-3-vertical" icon-library="default" (click)="showDeviceInfo(item)"></qds-icon>
              
              <div *ngIf="isDeviceInfoVisible === item" class="device-info-popup">
                <div class="device-info-content">
                    <div class="device-info-inner">
                        <div class="device-info-share-header">
                            <div class="device-info-icon-container">
                                <div class="device-info-icon-bg"></div>
                            </div>
                            <div class="device-info-flex-column">
                                
                                <qds-list-item class="device-info-share-title"> Share Device </qds-list-item>

                            </div>
                            <div class="device-info-divider"></div>
                        </div>
                        <div class="device-info-field">
                            <qds-list-item> {{item.ownerName}} </qds-list-item>
                            <div class="device-info-flex-column">
                                <div class="device-info-field-label">Owner Name</div>
                                
                                <qds-list-item class="device-info-field-value"> {{item.ownerName}} </qds-list-item>

                            </div>
                        </div>
                        <div class="device-info-field">
                            <div class="device-info-flex-column">
                                <div class="device-info-field-label">Software Version </div>
                                <div class="device-info-field-value">{{item.firmwareVersion}}</div>
                            </div>
                        </div>
                        <div class="device-info-link-container">
                            <div class="device-info-link-inner">
                                
                                <div class="device-info-link-flex"><span class="device-info-link-text">Technical Document Link </span><span class="device-info-link-icon">action_new_window</span></div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </div>

          </div>
          
      </p-accordionTab>  
      </p-accordion>
  </div>
</div> -->
